import React, { useState, useRef } from 'react';

import { ThemeProps, withTheme } from 'styled-components';

import { Container, Content, Label, Value } from './styles';

export interface RenderProps {
  show: boolean;
  selectRef: React.RefObject<HTMLDivElement>;
  onClose: () => void;
  onChange: (value: any) => void;
}

interface Props extends ThemeProps<any> {
  label: string;
  placeholder?: string;
  value?: string;
  children: (renderProps: RenderProps) => JSX.Element;
  onChange: (value: any) => void;
  disabled?: boolean;
  icon?: React.ReactNode;
  testId?: string;
}

const BookingSelectDate = ({ label, placeholder, value, disabled, children, onChange, icon, testId }: Props) => {
  const selectRef = useRef(null);

  const [showOptions, setShowOptions] = useState(false);

  const handleContainerClick = () => {
    setShowOptions(!showOptions);
  };

  const handleOptionsClose = () => {
    setShowOptions(false);
  };

  return (
    <Container ref={selectRef} $disabled={disabled}>
      <Content onClick={() => (disabled ? null : handleContainerClick())} data-testid={testId}>
        <Label>{label}</Label>
        <Value active={!!value}>{value || placeholder || label}</Value>
      </Content>
      {icon}
      {children({
        show: showOptions,
        onClose: handleOptionsClose,
        selectRef,
        onChange,
      })}
    </Container>
  );
};

export default withTheme(BookingSelectDate);
